<template>
  <authorization permissionKey="island_therapy_queue" can="read">
    <Attendances
      queueType="therapy_exam"
      :attendancePlaceId="attendancePlaceId"
    >
      <template v-slot:attendance="{ attendance }">
        <AttendanceTherapyList :attendance="attendance" />
      </template>
    </Attendances>
  </authorization>
</template>

<script>
import Attendances from "@/components/queues/attendances.vue";
import AttendanceTherapyList from "@/components/attendance_therapy/list/index.vue";

export default {
  name: "TherapyExam",
  components: {
    Attendances,
    AttendanceTherapyList,
  },
  props: {
    attendancePlaceId: String,
  },
};
</script>

<style lang="scss" scoped></style>
